export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'displayImage',
    align: 'center',
    width: 120,
    slots: { default: 'displayImage' },
  },
  {
    title: '产品名称',
    field: 'productName',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'productName' },
  },
  {
    title: '尺寸颜色',
    field: 'sizeColor',
    minWidth: 160,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'sizeColor' },
  },
  {
    title: '确认下单数量',
    field: 'confirmOrderQuantity',
    minWidth: 110,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'confirmOrderQuantity' },
  },
  {
    title: '下单价格',
    field: 'price',
    minWidth: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'price' },
  },
  {
    title: '成本价/工厂',
    field: 'costPriceFactory',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'costPriceFactory' },
  },
  {
    title: '产品面料',
    field: 'productMaterial',
    minWidth: 300,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: '最新变动',
    field: 'latestChanges',
    minWidth: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'latestChanges' },
  },
]
